import { render, staticRenderFns } from "./extra-telefonliste.vue?vue&type=template&id=f2e28858&scoped=true&lang=pug&"
import script from "./extra-telefonliste.vue?vue&type=script&lang=js&"
export * from "./extra-telefonliste.vue?vue&type=script&lang=js&"
import style0 from "./extra-telefonliste.vue?vue&type=style&index=0&id=f2e28858&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e28858",
  null
  
)

export default component.exports